import React from "react";
import ProductModal from "../ProductModel/ProductModal";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import milkImg from "../../imgs/milk.png";
import juiceImg from "../../imgs/juice.png";
import "./ProductTable.css";

class ProductTable extends React.Component {
  state = {
    showModal: false,
    productName: "",
    productImage: "",
  };
  openModel = (ModalStatus, productImage, productName) => {
    this.setState({
      showModal: ModalStatus,
      productName,
      productImage,
    });
  };
  render() {
    let players = [
      {
        name: "1. Dairy",
        picture: milkImg,
        brand_name: "Dairy Milk",
        hs_code: "99 10 151",
        description:
          "The firsh dairy sector is the main sector of Almarai's bussiness representing more than 40% of the company sales.",
        cpc_code: "15566 to 23556",
      },
      {
        name: "2. Juice",
        picture: juiceImg,
        brand_name: "Farms Select",
        hs_code: "99 10 160",
        description:
          "The % Daily value (DV) tells you how much nutrient in a serving of food contributes to a daily diet. 2000 calories a day is used for general nutritioan advice.",
        cpc_code: "15576 to 25556",
      },
    ];
    for (let i = 0; i < players.length; i++) {
      players[i].picture = (
        <img
          src={players[i].picture}
          onClick={(e) =>
            this.openModel(true, players[i].picture, players[i].name)
          }
          alt={players[i].name}
        />
      );
    }
    let columns = [
      {
        dataField: "name",
        text: "Goods&Services Name",
        align: "left",
      },
      {
        dataField: "picture",
        text: "Picture",
      },
      {
        dataField: "brand_name",
        text: "Brand Name",
      },
      {
        dataField: "hs_code",
        text: "HS Code",
      },
      {
        dataField: "description",
        text: "Description",
        align: "left",
      },
      {
        dataField: "cpc_code",
        text: "CPC Code",
      },
    ];
    return (
      <>
        <BootstrapTable keyField="name" data={players} columns={columns} />
        <ProductModal
          show={this.state.showModal}
          onHide={() => this.openModel(false)}
          productName={this.state.productName}
          productImage={this.state.productImage}
        />
      </>
    );
  }
}

export default ProductTable;
